import { faCircleMinus } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a circle with minus icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/circle-minus?f=classic&s=solid
 */
export function CircleMinusIcon(props: CustomIconProps) {
  return <Icon icon={faCircleMinus} {...props} />;
}
